module.exports = __webpack_public_path__ + "static/media/21a Sprawl.65da86ce.jpg";